export const FETCH_OPTIONS_REQUEST = 'FETCH_OPTIONS_REQUEST';
export const FETCH_OPTIONS_SUCCESS = 'FETCH_OPTIONS_SUCCESS';
export const FETCH_OPTIONS_ERROR = 'FETCH_OPTIONS_ERROR';
